export const FEATURES_LIST = [{
  title: '拓宽展业渠道，解决展业问题',
  desc: '为投顾人员提供互联网上的展业渠道，扩大投顾的服务半径和影响力',
  img: 'investment-advisor/channels.jpg'
}, {
  title: '助力机构完成财富管理转型',
  desc: '为客户提供理财规划服务，双方利益趋于一致，驱动机构完成财富管理转型',
  img: 'investment-advisor/wealth.jpg'
}, {
  title: '建立用户信任，提高用户黏性',
  desc: '从卖方投顾转向买方投顾，能够推进客户服务深度，拉近用户距离',
  img: 'investment-advisor/trush.jpg'
}, {
  title: '打破产品鸿沟，产生涟漪效益',
  desc: '着眼未来，增加用户对特定的产品或业务的信任和认可，将为其它相关产品和业务带来涟漪效益',
  img: 'investment-advisor/ripple.jpg'
}];
export const SKILL_LIST = [{
  type: '前台功能',
  category: [{
    img: 'ProduceArticles.png',
    title: '产文章',
    desc: '为用户提供免费的陪伴式服务，包括但不限于大盘解读、热点解析、投资者教育以及必要时的心理疏导等。通过持续性的内容输出实现自我营销和吸粉，为后续的付费转化打下基础'
  }, {
    img: 'WatchA.png',
    title: '看直播',
    desc: '支持视频直播和录播功能，赋能优秀投顾通过视频的形式更直接地进行吸粉及教学，增加粉丝黏性，提高营销转化'
  }, {
    img: 'ReadingOpinions.png',
    title: '读观点',
    desc: '观点文章是独立的行情解读、后市研判、个股研究或系列课程的教学等，该功能支持打赏或付费阅读，是投顾的主要收入来源之一'
  }, {
    img: 'wgp.png',
    title: '问股票',
    desc: '由投顾老师通过免费诊股、签约诊股以及付费诊股的层层引导，最终将活跃用户转化为付费用户'
  }, {
    img: 'gzh.png',
    title: '跟组合',
    desc: '一方面，可通过模拟炒股结合投顾自身操盘风格，创建丰富的股票组合，用硬实圈粉；另一方面，可通过同花顺mindgo为每一位客户量身定制个性化投资产品组合，为投资做出及时的投资平衡建议'
  }]
}, {
  type: '后台功能',
  category: [{
    img: 'AI投顾辅助.png',
    title: 'AI投顾辅助',
    desc: '结合大数据分析、人工智能与投顾平台相结合，整合多方优势。为投顾提升一站式辅助资源库，提升投顾的服务质量和服务效率'
  }, {
    img: 'monitoring.png',
    title: '舆情监控',
    desc: '包含公司新闻，财务风险、事件预警、管理预警、违约风险等36+预警分类体系，全方位监控市场异动，关联CRM系统后可及时对客户进行预警并进行关怀指导'
  }, {
    img: 'shareholders.png',
    title: '股民画像',
    desc: '通过客户大数据分析，行为分析等精准所识别客户属性，帮助投顾更好地了解客户，实现精细化运营'
  }, {
    img: 'appraisalSystem.png',
    title: '绩效考核系统',
    desc: '提供集中式管理、营业部分部式等多种管理方式，通过指标指定、任务分配、奖惩激励、晋升降职等一站式高度自定义配置功能，实现投顾管理的全面性，为投顾职业发展提供公平可靠的管理体系'
  }, {
    img: 'FOF研究中心.png',
    title: 'FOF研究中心',
    desc: '实现基金产品分析，为投顾提供更全面的产品组合，实现客户财富增值，体现投顾价值'
  }]
}];